import { ls } from '@/utils/tool';

/** 
 * 判断注册新健康卡是否冲突
*   @param {*} opt 传入opt包括from表单
*   @param return 返回true表示可以注册
*/
export const filter = (opt) => {
    const idCard = ls.get('sysUser').relationRecords
    try {
        idCard.forEach(item => {
            console.log(item,opt)
            if (opt.idCard == item.idCard||opt.idCard.toLocaleUpperCase()==item.idCard||opt.idCard.toLocaleLowerCase()==item.idCard) {
                throw new Error('报错了')
            }
        })
        return true
    } catch (e) {
        return false
    }
}
